import { render } from "./AllowEarningToggleButton.vue?vue&type=template&id=4381a5ec"
import script from "./AllowEarningToggleButton.vue?vue&type=script&lang=js"
export * from "./AllowEarningToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__